<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>发放优惠券</span>
      <el-button type="primary" style="width: 92px" @click="back" size="medium"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container" style="padding: 10px 20px 20px 20px">
        <el-form
          :model="diagnosisCouponIssueForm"
          :rules="rules"
          ref="diagnosisCouponIssueRef"
          label-width="110px"
          class="diagnosisCouponIssue-ruleForm"
        >
          <el-form-item label="优惠券名称">
            {{ diagnosisCouponIssueForm.coupon_name }}
          </el-form-item>
          <el-form-item
            v-if="diagnosisCouponIssueForm.time_limit == 2"
            label="使用时间"
          >
            {{ diagnosisCouponIssueForm.time_start | dateFormat }} -
            {{ diagnosisCouponIssueForm.time_end | dateFormat }}
          </el-form-item>
          <el-form-item v-else label="使用时间">
            领取后{{ diagnosisCouponIssueForm.time_days }}天
          </el-form-item>
          <el-form-item label="使用门槛">
            {{
              diagnosisCouponIssueForm.money == 0
                ? "无门槛"
                : diagnosisCouponIssueForm.money
            }}
          </el-form-item>
          <el-form-item label="优惠券类型">
            <span v-if="diagnosisCouponIssueForm.coupon_types == 3"
              >包邮券</span
            >
            <span v-else>
              {{
                diagnosisCouponIssueForm.coupon_type == 1
                  ? `减免券(减${diagnosisCouponIssueForm.enough}元)`
                  : "打折券"
              }}
            </span>
          </el-form-item>
          <el-form-item label="退还方式">
            {{ diagnosisCouponIssueForm.return_type == 1 ? "不退还" : "退还" }}
          </el-form-item>

          <el-form-item label="是否可分享">
            {{ diagnosisCouponIssueForm.is_share == 1 ? "可分享" : "不可分享" }}
          </el-form-item>

          <el-form-item label="短信通知" prop="is_send_msg">
            <el-radio-group
              v-model="diagnosisCouponIssueForm.is_send_msg"
              style="padding-top: 4px"
            >
              <el-radio :label="1">发送</el-radio>
              <el-radio :label="0">不发送</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="每人数量" prop="num">
            <el-input-number
              v-model="diagnosisCouponIssueForm.num"
              size="small"
              :min="1"
              :max="999999999"
              :precision="0"
              :controls="false"
            ></el-input-number>
            <span>&nbsp;发放给每个人的数量</span>
          </el-form-item>

          <el-form-item label="发放用户" prop="user_type">
            <el-tabs
              v-model="diagnosisCouponIssueForm.user_type"
              style="margin-left: 10px"
            >
              <el-tab-pane
                label="医生"
                name="1"
                :disabled="diagnosisCouponIssueForm.coupon_types != 3"
              ></el-tab-pane>
              <el-tab-pane label="用户" name="2"></el-tab-pane>
            </el-tabs>
          </el-form-item>

          <el-form-item label=" " prop="grant_type">
            <el-radio-group
              v-model="diagnosisCouponIssueForm.grant_type"
              @input="grantTypeChange"
            >
              <el-radio :label="1"
                >选择{{
                  diagnosisCouponIssueForm.user_type | grant_typeText
                }}</el-radio
              >
              <el-radio :label="2"
                >选择{{
                  diagnosisCouponIssueForm.user_type | grant_typeText
                }}标签</el-radio
              >
              <el-radio :label="3"
                >批量录入{{
                  diagnosisCouponIssueForm.user_type | grant_typeText
                }}</el-radio
              >
            </el-radio-group>
          </el-form-item>

          <template v-if="diagnosisCouponIssueForm.user_type == 1">
            <!-- 选择医生 -->
            <el-form-item
              v-if="diagnosisCouponIssueForm.grant_type == 1"
              label=" "
              class="show-object-user"
            >
              <div class="user-box">
                <div class="left-table">
                  <div class="header">
                    <span class="title">未选医生</span>
                    <span class="limt"
                      >{{ totalNum - confirmDoctor.length }}/{{
                        totalNum
                      }}</span
                    >
                  </div>
                  <div class="search">
                    <el-input
                      placeholder="请输入手机号"
                      v-model="selectDoctorKeywords"
                      :show-message="false"
                      size="small"
                      clearable
                      class="input-with-select"
                    >
                      <el-button
                        slot="append"
                        icon="el-icon-search"
                        @click="searchDoctorList(1)"
                      ></el-button>
                    </el-input>
                  </div>
                  <el-table
                    ref="multipleTable"
                    :data="transferDoctorData"
                    border
                    height="400"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionDoctorChange"
                  >
                    <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column label="医生名称" prop="doctor_name">
                    </el-table-column>
                    <el-table-column label="医生手机号" prop="phone">
                    </el-table-column>
                    <el-table-column label="已发放数" prop="already_num">
                    </el-table-column>
                  </el-table>
                  <!-- 分页 -->
                  <pagination
                    v-show="totalNum > 0"
                    :total="totalNum"
                    :page.sync="pagination.page"
                    layout="total, prev, pager, next"
                    :limit.sync="pagination.pageNumber"
                    @pagination="getAllDoctorList"
                  />
                </div>
                <div class="btn-box-user">
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-arrow-left"
                    @click="leftDoctorClick"
                  ></el-button>
                  <el-button
                    type="primary"
                    size="small"
                    @click="rightDoctorClick"
                    ><i class="el-icon-arrow-right el-icon--right"></i
                  ></el-button>
                </div>
                <div class="right-table">
                  <div class="header">
                    <span class="title">已选医生</span>
                    <span class="limt"
                      >{{ confirmDoctor.length }}/{{ totalNum }}</span
                    >
                  </div>
                  <div class="search">
                    <el-input
                      placeholder="请输入手机号"
                      v-model="confirmDoctorKeywords"
                      size="small"
                      clearable
                      class="input-with-select"
                    >
                      <el-button
                        slot="append"
                        icon="el-icon-search"
                        @click="searchDoctorList(2)"
                      ></el-button>
                    </el-input>
                  </div>
                  <el-table
                    ref="rightMultipleTable"
                    :data="confirmDoctor"
                    height="400"
                    tooltip-effect="dark"
                    border
                    style="width: 100%"
                    @selection-change="handleSelectionDoctorRightChange"
                  >
                    <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column label="医生名称" prop="doctor_name">
                    </el-table-column>
                    <el-table-column label="医生手机号" prop="phone">
                    </el-table-column>
                    <el-table-column label="已发放数" prop="already_num">
                    </el-table-column>
                  </el-table>
                  <!-- 分页占位 -->
                  <pagination
                    style="opacity: 0"
                    :total="totalNum"
                    :page.sync="pagination.page"
                    layout="total, prev, pager, next"
                    :limit.sync="pagination.pageNumber"
                    @pagination="getAllDoctorList"
                  />
                </div>
              </div>
            </el-form-item>

            <!-- 选择医生标签 -->
            <el-form-item
              v-if="diagnosisCouponIssueForm.grant_type == 2"
              label=" "
            >
              <span>选择医生标签</span>
              <el-select
                v-model="diagnosisCouponIssueForm.grant_key"
                style="width: 400px !important; margin-left: 10px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in doctorOptions"
                  :key="item.label_id"
                  :label="item.label_name"
                  :value="item.label_id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <!-- 批量录入医生 -->
            <el-form-item
              v-if="diagnosisCouponIssueForm.grant_type == 3"
              label=" "
              class="cus-textarea"
            >
              <el-input
                type="textarea"
                v-model="diagnosisCouponIssueForm.grant_key"
                :rows="13"
                placeholder="请输入医生手机号，多个用逗号隔开"
              ></el-input>
            </el-form-item>
          </template>

          <template v-if="diagnosisCouponIssueForm.user_type == 2">
            <!-- 选择用户 -->
            <el-form-item
              v-if="diagnosisCouponIssueForm.grant_type == 1"
              label=" "
              class="show-object-user"
            >
              <div class="user-box">
                <div class="left-table">
                  <div class="header">
                    <span class="title">未选用户</span>
                    <span class="limt"
                      >{{ totalNum - confirmUser.length }}/{{ totalNum }}</span
                    >
                  </div>
                  <div class="search">
                    <el-input
                      placeholder="请输入手机号"
                      v-model="selectUserKeywords"
                      :show-message="false"
                      size="small"
                      clearable
                      class="input-with-select"
                    >
                      <el-button
                        slot="append"
                        icon="el-icon-search"
                        @click="searchUserList(1)"
                      ></el-button>
                    </el-input>
                  </div>
                  <el-table
                    ref="multipleTable"
                    :data="transferData"
                    border
                    height="400"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                  >
                    <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column label="用户昵称" prop="nick_name">
                    </el-table-column>
                    <el-table-column label="用户手机号" prop="phone">
                    </el-table-column>
                    <el-table-column label="已发放数" prop="already_num">
                    </el-table-column>
                  </el-table>
                  <!-- 分页 -->
                  <pagination
                    v-show="totalNum > 0"
                    :total="totalNum"
                    :page.sync="pagination.page"
                    layout="total, prev, pager, next"
                    :limit.sync="pagination.pageNumber"
                    @pagination="getAllUserList"
                  />
                </div>
                <div class="btn-box-user">
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-arrow-left"
                    @click="leftClick"
                  ></el-button>
                  <el-button type="primary" size="small" @click="rightClick"
                    ><i class="el-icon-arrow-right el-icon--right"></i
                  ></el-button>
                </div>
                <div class="right-table">
                  <div class="header">
                    <span class="title">已选用户</span>
                    <span class="limt"
                      >{{ confirmUser.length }}/{{ totalNum }}</span
                    >
                  </div>
                  <div class="search">
                    <el-input
                      placeholder="请输入手机号"
                      v-model="confirmUserKeywords"
                      size="small"
                      clearable
                      class="input-with-select"
                    >
                      <el-button
                        slot="append"
                        icon="el-icon-search"
                        @click="searchUserList(2)"
                      ></el-button>
                    </el-input>
                  </div>
                  <el-table
                    ref="rightMultipleTable"
                    :data="confirmUser"
                    height="400"
                    tooltip-effect="dark"
                    border
                    style="width: 100%"
                    @selection-change="handleSelectionRightChange"
                  >
                    <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column label="用户昵称" prop="nick_name">
                    </el-table-column>
                    <el-table-column label="用户手机号" prop="phone">
                    </el-table-column>
                    <el-table-column label="已发放数" prop="already_num">
                    </el-table-column>
                  </el-table>
                  <!-- 分页占位 -->
                  <pagination
                    style="opacity: 0"
                    :total="totalNum"
                    :page.sync="pagination.page"
                    layout="total, prev, pager, next"
                    :limit.sync="pagination.pageNumber"
                    @pagination="getAllUserList"
                  />
                </div>
              </div>
            </el-form-item>

            <!-- 选择用户标签 -->
            <el-form-item
              v-if="diagnosisCouponIssueForm.grant_type == 2"
              label=" "
            >
              <span>选择用户标签</span>
              <el-select
                v-model="diagnosisCouponIssueForm.grant_key"
                style="width: 400px !important; margin-left: 10px"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in userOptions"
                  :key="item.label_id"
                  :label="item.label_name"
                  :value="item.label_id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
              v-if="diagnosisCouponIssueForm.grant_type == 3"
              label=" "
              class="cus-textarea"
            >
              <el-input
                type="textarea"
                v-model="diagnosisCouponIssueForm.grant_key"
                :rows="13"
                placeholder="请输入医生手机号，多个用逗号隔开"
              ></el-input>
            </el-form-item>
          </template>

          <el-form-item class="btn-box">
            <el-button @click="back">取 消</el-button>
            <el-button
              type="primary"
              @click="saveBtn('diagnosisCouponIssueRef')"
              >确 定</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "dayjs";
import marketing from "@/api/marketing.js";
import doctor from "@/api/doctor.js";
import common from "@/api/common.js";
import Pagination from "@/components/Pagination/index";
export default {
  components: {
    Pagination,
  },
  data() {
    const validateGrantType = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请选择"));
      } else if (value == 3 && !this.diagnosisCouponIssueForm.grant_key) {
        callback(new Error("请选择用户"));
      } else {
        callback();
      }
    };

    return {
      diagnosisCouponIssueForm: {
        coupon_name: "",
        time_limit: "",
        time_days: "",
        time_start: "",
        time_end: "",
        coupon_type: "",
        enough: "",
        return_type: "",
        is_send_msg: 1,
        num: undefined,
        user_type: "1",
        grant_type: 1,
        grant_key: "",
      },
      rules: {
        is_send_msg: [{ required: true, message: "请选择", trigger: "change" }],
        num: [{ required: true, message: "请输入", trigger: "blur" }],
        // grant_type: [
        //   { required: true, validator: validateGrantType, trigger: "change" },
        // ],
      },
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 15,
      },
      transferData: [],
      selectUserVal: [],
      rightSelectUserVal: [],
      confirmUser: [],
      cloneDeepConfirmUser: [],
      selectUserKeywords: "",
      confirmUserKeywords: "",
      userOptions: [],
      // 医生
      transferDoctorData: [],
      selectDoctorVal: [],
      rightSelectDoctorVal: [],
      confirmDoctor: [],
      cloneDeepConfirmDoctor: [],
      selectDoctorKeywords: "",
      confirmDoctorKeywords: "",
      doctorOptions: [],
    };
  },
  filters: {
    dateFormat(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD");
    },
    grant_typeText(val) {
      switch (val) {
        case "1":
          return "医生";
        case "2":
          return "用户";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    routeQuery() {
      return this.$route.query;
    },
  },
  created() {
    this.getCouponInfo();
  },
  watch: {
    "diagnosisCouponIssueForm.user_type": {
      handler(newVal, oldVal) {
        if (newVal === "1") {
          this.totalNum = 0;
          this.pagination = {
            page: 1,
            pageNumber: 15,
          };
          this.transferDoctorData = [];
          this.selectDoctorVal = [];
          this.rightSelectDoctorVal = [];
          this.confirmDoctor = [];
          this.cloneDeepConfirmDoctor = [];
          this.selectDoctorKeywords = "";
          this.confirmDoctorKeywords = "";
          this.getAllDoctorList();
        } else if (newVal === "2") {
          this.totalNum = 0;
          this.pagination = {
            page: 1,
            pageNumber: 15,
          };
          this.transferData = [];
          this.selectUserVal = [];
          this.rightSelectUserVal = [];
          this.confirmUser = [];
          this.cloneDeepConfirmUser = [];
          this.selectUserKeywords = "";
          this.confirmUserKeywords = "";
          this.getAllUserList();
        }
        this.diagnosisCouponIssueForm.grant_type = 1;
      },
      immediate: true,
    },
  },
  methods: {
    getCouponInfo() {
      const loading = this.$loading();
      let params = {
        coupon_data_id: this.routeQuery.coupon_data_id,
      };
      marketing
        .getCouponInfo(params)
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.diagnosisCouponIssueForm = Object.assign(
              {},
              this.diagnosisCouponIssueForm,
              data.info
            );
            this.diagnosisCouponIssueForm.time_days = !data.info.time_days
              ? undefined
              : data.info.time_days;
            if (this.diagnosisCouponIssueForm.coupon_types == 3) {
              this.diagnosisCouponIssueForm.user_type = "1";
              this.getAllDoctorList();
            } else {
              this.diagnosisCouponIssueForm.user_type = "2";
              tahis.getAllUserList();
            }
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    saveBtn(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = _.pick(this.diagnosisCouponIssueForm, [
            "user_type",
            "grant_type",
            "num",
            "grant_key",
            "is_send_msg",
          ]);
          params.coupon_data_id = this.routeQuery.coupon_data_id;

          const loading = this.$loading();
          marketing
            .grantUserCoupon(params)
            .then((res) => {
              let { code } = res;
              if (code === 0) {
                this.$message.success("发放成功");
                this.back();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 验证
    grantTypeChange(val) {
      console.log(val);
      let { user_type } = this.diagnosisCouponIssueForm;
      switch (val) {
        case 1:
          user_type == 1 ? this.getAllDoctorList() : this.getAllUserList();
          break;
        case 2:
          user_type == 1 ? this.getDoctorLabelList() : this.getUserLabelList();
          break;
        case 3:
          break;
      }
    },
    // 获取医生标签
    //获取医生标签列表
    getDoctorLabelList() {
      let data = {
        page: 1,
        pageNumber: 9999999,
        label_status: 1,
      };
      this.axios.post("platform/Doctor/doctorLabelList", data).then((res) => {
        if (res.code == 0) {
          this.doctorOptions = res.data.list;
        }
      });
    },
    //获取用户标签列表
    getUserLabelList() {
      let data = {
        page: 1,
        pageNumber: 9999999,
        label_status: 1,
      };
      this.axios.post("platform/patient/userLabelList", data).then((res) => {
        if (res.code == 0) {
          this.userOptions = res.data.list;
        }
      });
    },
    /* **** 选择用户---start **** */
    searchUserList(type) {
      switch (type) {
        case 1:
          this.pagination.page = 1;
          this.getAllUserList();
          break;

        case 2:
          if (this.confirmUserKeywords != "") {
            this.confirmUser = this.cloneDeepConfirmUser.filter((item) => {
              return (
                item.nick_name == this.confirmUserKeywords ||
                item.phone == this.confirmUserKeywords
              );
            });
          } else {
            this.confirmUser = this.cloneDeepConfirmUser;
          }

          break;
      }
    },
    getAllUserList() {
      let params = Object.assign(
        {},
        { keywords: this.selectUserKeywords },
        this.pagination
      );
      common.getAllUserList(params).then((res) => {
        let { code, data } = res;
        if (code === 0) {
          this.transferData = data.list;
          this.totalNum = data.total;

          this.$nextTick(() => {
            this.confirmUser.forEach((row) => {
              this.$refs.multipleTable.toggleRowSelection(
                this.transferData.find((item) => row.user_id == item.user_id),
                true
              );
            });
          });
        }
      });
    },
    handleSelectionChange(e) {
      this.selectUserVal = _.unionBy(e, this.confirmUser, "user_id");
    },
    handleSelectionRightChange(e) {
      this.rightSelectUserVal = e;
    },
    leftClick() {
      if (!this.rightSelectUserVal.length) {
        this.$message.warning("请选择");
        return;
      }
      let arr = _.xorWith(
        this.selectUserVal,
        this.rightSelectUserVal,
        _.isEqual
      ).filter((item) => item);

      if (!arr.length) {
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$nextTick(() => {
          this.$refs.multipleTable.clearSelection();
          arr.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(
              this.transferData.find((item) => row.user_id == item.user_id),
              true
            );
          });
        });
      }
      this.confirmUser = arr;
      this.diagnosisCouponIssueForm.grant_key = arr
        .map((item) => item.user_id)
        .join(",");
      this.cloneDeepConfirmUser = _.cloneDeep(this.confirmUser);
      this.selectUserVal = arr;
    },
    rightClick() {
      if (!this.selectUserVal.length) {
        this.$message.warning("请选择");
        return;
      }
      this.confirmUser = JSON.parse(JSON.stringify(this.selectUserVal)).filter(
        (item) => item
      );
      this.cloneDeepConfirmUser = _.cloneDeep(this.confirmUser);
      this.diagnosisCouponIssueForm.grant_key = this.confirmUser
        .map((item) => item.user_id)
        .join(",");
      this.$nextTick(() => {
        this.confirmUser.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(
            this.transferData.find((item) => row.user_id == item.user_id),
            true
          );
        });
      });
    },
    /* **** 选择用户---end **** */

    /* **** 选择医生---start **** */
    searchDoctorList(type) {
      switch (type) {
        case 1:
          this.pagination.page = 1;
          this.getAllDoctorList();
          break;

        case 2:
          if (this.confirmDoctorKeywords != "") {
            this.confirmDoctor = this.cloneDeepConfirmDoctor.filter((item) => {
              return (
                item.doctor_name == this.confirmDoctorKeywords ||
                item.phone == this.confirmDoctorKeywords
              );
            });
          } else {
            this.confirmDoctor = this.cloneDeepConfirmDoctor;
          }

          break;
      }
    },
    getAllDoctorList() {
      let params = Object.assign(
        {},
        {
          doctor_phone: this.selectDoctorKeywords,
          auth_status: 2,
          coupon_data_id: this.routeQuery.coupon_data_id,
        },
        this.pagination
      );
      doctor.doctorList(params).then((res) => {
        let { code, data } = res;
        if (code === 0) {
          this.transferDoctorData = data.list;
          this.totalNum = data.total;

          this.$nextTick(() => {
            this.confirmDoctor.forEach((row) => {
              this.$refs.multipleTable.toggleRowSelection(
                this.transferDoctorData.find(
                  (item) => row.doctor_id == item.doctor_id
                ),
                true
              );
            });
          });
        }
      });
    },
    handleSelectionDoctorChange(e) {
      this.selectDoctorVal = _.unionBy(e, this.confirmDoctor, "doctor_id");
    },
    handleSelectionDoctorRightChange(e) {
      this.rightSelectDoctorVal = e;
    },
    leftDoctorClick() {
      if (!this.rightSelectDoctorVal.length) {
        this.$message.warning("请选择");
        return;
      }
      let arr = _.xorWith(
        this.selectDoctorVal,
        this.rightSelectDoctorVal,
        _.isEqual
      ).filter((item) => item);

      if (!arr.length) {
        this.$refs.multipleTable.clearSelection();
      } else {
        this.$nextTick(() => {
          this.$refs.multipleTable.clearSelection();
          arr.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(
              this.transferDoctorData.find(
                (item) => row.doctor_id == item.doctor_id
              ),
              true
            );
          });
        });
      }
      this.confirmDoctor = arr;
      this.diagnosisCouponIssueForm.grant_key = arr
        .map((item) => item.doctor_id)
        .join(",");
      this.cloneDeepConfirmDoctor = _.cloneDeep(this.confirmDoctor);
      this.selectDoctorVal = arr;
    },
    rightDoctorClick() {
      if (!this.selectDoctorVal.length) {
        this.$message.warning("请选择");
        return;
      }
      this.confirmDoctor = JSON.parse(
        JSON.stringify(this.selectDoctorVal)
      ).filter((item) => item);
      this.cloneDeepConfirmDoctor = _.cloneDeep(this.confirmDoctor);
      this.diagnosisCouponIssueForm.grant_key = this.confirmDoctor
        .map((item) => item.doctor_id)
        .join(",");
      this.$nextTick(() => {
        this.confirmDoctor.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(
            this.transferDoctorData.find(
              (item) => row.doctor_id == item.doctor_id
            ),
            true
          );
        });
      });
    },
    /* **** 选择用户---end **** */
    back() {
      history.back();
    },
  },
};
</script>

<style lang="scss" scoped >
/* 全局修复 */
.el-radio__original[aria-hidden] {
  aria-hidden: false !important;
}
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.diagnosisCouponIssue-ruleForm {
  .el-form-item {
    display: flex;
    align-items: center;
    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
      display: flex;
      align-items: center;
      .sub_title {
        display: inline-block;
        width: 80px;
        text-align: left;
      }
    }
  }
  .cus-textarea {
    ::v-deep .el-form-item__content {
      width: 800px;
      height: auto;
    }
  }

  .show-object-user {
    ::v-deep .el-form-item__content {
      height: auto;
    }
    .user-box {
      display: flex;
      .header {
        height: 40px;
        line-height: 40px;
        border: 1px solid #ebeef5;
        border-bottom: none;
        padding-left: 10px;
        .title {
          font-size: 16px;
          font-weight: bold;
          margin-right: 10px;
        }
        .limt {
          font-size: 14px;
          font-weight: bold;
        }
      }
      .search {
        border: 1px solid #ebeef5;
        border-bottom: none;
        padding: 10px 40px;
      }
      .left-table {
        width: 400px;
      }
      .btn-box-user {
        margin: 0 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .right-table {
        width: 400px;
      }
    }
  }
  .btn-box {
    padding-left: 200px;
  }
}
</style>